import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    data: {},
    selectedStore: false,
    storeSelectionId: 0,
    googleMapsApiLoaded: false,
    storeLetterList: [],
    rtsData: [],
    apiParameters: {},
    pagination: {},
});

const reducers = (state = initialState(), { type, payload }) => {
    switch (type) {
        case types.SET_STORES_DATA:
            return {
                ...state,
                pagination: {},
                data: { ...payload },
            };

        case types.GET_STORES_LETTERS:
            return {
                ...state,
                storeLetterList: [...payload],
            };

        case types.SET_CURRENT_PAGE:
            return reduceAction(state, 'pagination', payload);

        case types.SET_RTS_STORES_DATA:
            return {
                ...state,
                rtsData: { ...payload },
            };

        case types.SELECT_STORE: {
            return {
                ...state,
                selectedStore: !!payload && payload,
                storeSelectionId: state.storeSelectionId + 1,
            };
        }

        case types.SET_ERROR_STATE:
            return reduceAction(state, 'error', payload);

        case types.SET_ERROR_TYPE:
            return reduceAction(state, 'errorType', payload);

        case types.RESET_ERROR:
            return { ...state, isError: false, errorType: '' };

        case types.SET_QUERY_VALUE:
            return reduceAction(state, 'queryRequired', payload);

        case types.SET_GOOGLE_MAPS_API_LOADED:
            return reduceAction(state, 'googleMapsApiLoaded', true);

        case types.SAVE_API_PARAMETERS:
            return reduceAction(state, 'apiParameters', payload);

        case types.SET_PICK_UP_EXPRESS_STOREID:
            return reduceAction(state, 'pickUpExpressStoreId', payload);

        default:
            return state;
    }
};

export default reducers;
